interface AscendLogoProps {
  className?: string;
  size?: number;
}

/**
 * Official Ascend symbol logo (2026 brandkit).
 * 8-point mountain-peak polygon. Uses currentColor so callers control colour
 * via CSS / Tailwind text classes.
 */
export function AscendLogo({ className, size = 32 }: AscendLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 457.38 415.27"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <polygon
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={12}
        points="25.92 380.66 228.85 12.42 432.09 380.66 301.12 251.33 286.2 266.14 228.85 139.78 170.98 264.17 154.4 251.33 25.92 380.66"
      />
    </svg>
  );
}
